<template>
    <tr class="clickable-row">
        <td><a href="" @click.prevent.stop>{{subscription.client.full_name}}</a></td>
        <td><a href="" @click.prevent.stop>{{getDateStringFromISO(subscription.created_date)}}</a></td>
        <td><a href="" @click.prevent.stop>{{getShortDateString(subscription.start_date)}}</a></td>
        <td><a href="" @click.prevent.stop>{{getShortDateString(subscription.expired_date)}}</a></td>
        <td v-if="subscription.type.unlimited_redeemable"><a href="" @click.prevent.stop>({{ $t('components.subscription_type.appointment_unlimited') }})</a></td>
        <td v-else><a href="" @click.prevent.stop>{{subscription.residual_redeemable_appointments}} {{ $t('components.subscription.residual_appointments') }}</a></td>

    </tr>
</template>

<script>
    import {Utils} from "../../common/utils";

export default {
    name: "SubscriptionActiveRow",
    props: {
        subscription: {
            type: Object,
            require: true
        }
    },
    methods: {
        getShortDateString(date) {
            return Utils.getShortDateStringUTCFromISO(date)
        },
        getDateStringFromISO(date) {
            return Utils.getDateStringFromISO(date)
        }
    }
};
</script>
